const state = {
    queue: [],
}

const getters = {
}

const mutations = {
}

const actions = {
    async show (context, data) {
        const response = await axios.get('/api/v1/settings')
            .catch(error => error.response || null)
        return response
    },
    async save (context, data) {
        return axios.post('/api/v1/settings', data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


